<template>
    <span>
        <span v-if="application && withPreText">
            {{ $t('iFrame.onlineEventApp') }}
        </span>
        <a v-if="appointment && link && !plainText"
           :href="link"
           target="_blank">
            <span v-if="application">
                {{ application }}
            </span>
            <span v-else>
                {{ hideLink ? $t('iFrame.online') : link }}
            </span>
            <font-awesome-icon v-if="application || hideLink" icon="external-link-alt" size="xs"/>
        </a>
        <span v-else>
            <span v-if="application">
                {{ application }}
            </span>
            <span v-else>
                {{ $t('iFrame.online') }}
            </span>
        </span>
    </span>
</template>

<script>
export default {
    name: "EventEntryOnlineInfo",
    props: {
        appointment: Boolean,
        link: String,
        application: String,
        hideLink: {type: Boolean, default: false},
        plainText: {type: Boolean, default: false},
        withPreText: {type: Boolean, default: false}
    }
}
</script>

<style lang="scss" scoped>

</style>
